import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthSessionService } from '../services/auth-session.service';
import { TenantContextService } from '../services/tenant-context.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly authSession: AuthSessionService,
    private readonly router: Router,
    private readonly tenantContext: TenantContextService,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const token = this.authSession.getToken();
    const tenantSegment = this.tenantContext.getTenantRouteSegment();
    if (token) {
      if (this.authSession.isFirstLoginRequired() && !state.url.includes('/first-login')) {
        return this.router.createUrlTree(['/tenant', tenantSegment, 'first-login'], {
          queryParams: { returnUrl: state.url },
        });
      }
      return true;
    }
    void this.router.navigate(['/tenant', tenantSegment, 'login'], {
      queryParams: { returnUrl: state.url },
      replaceUrl: true,
    });
    return false;
  }
}
